import React from "react";
import NavigationComponent from "../../../commonComponents/util/NavigationComponent";
import Modal from "../../../commonComponents/util/Modal";
import LoadingSpinner from "../../../commonComponents/util/LoadingSpinner";
import BankReconciliationStep1 from "./BankReconciliationStep1";
import BankReconciliationStep2 from "./BankReconiliationStep2";

import { MonthNames } from "../../../../lib/constants";
import { Departments } from "../../../../lib/systemVariables";

export default class BankReconciliationModal extends NavigationComponent {
  constructor(props) {
    super(props);

    this.report = {
      dateFrom: "",
      dateTo: "",
      reportName: this.getReportName(),
      statementBalance: "",
      beginningBalance: "",
      transactionNotes: []
    };

    this.state = {
      isReady: false,
      report: this.report,
      step: 1
    };
  }

  componentWillUpdate(nextProps) {
    if (nextProps.show && !this.props.show) {
      const {
        fund: { fundId },
        reconciliationReports: {
          data: { reconciliationInProgressReportId }
        }
      } = nextProps;

      if (reconciliationInProgressReportId) {
        this.getInProgressReport(fundId, reconciliationInProgressReportId);
      } else {
        this.setState({
          isReady: true,
          report: {
            ...this.state.report,
            dateFrom:
              nextProps.reconciliationReports.data.lastReconciliationEndDate ||
              nextProps.fund.startingDate
          }
        });
      }
    }
  }

  getInProgressReport = async (fundId, reportId) => {
    await this.props.getReconciliationReport(fundId, reportId);

    const { reconciliationReportDetails } = this.props;
    if (reconciliationReportDetails.success) {
      const {
        pendingAdjustments,
        dateFrom,
        dateTo,
        endingBalance,
        pendingDeposits,
        pendingWithdrawals,
        beginningBalance,
        reportName
      } = reconciliationReportDetails.data;
      //select pending transactions for calc
      pendingDeposits.forEach(crdt => this.props.selectCredit(crdt));
      pendingWithdrawals.forEach(pymt => this.props.selectPayment(pymt));
      //set pending adjustments for calc
      this.props.updateAdjustments(pendingAdjustments);

      const transactionNotes = {};
      [...pendingDeposits, ...pendingWithdrawals].forEach(
        ({ transactionId, reconciliationNote }) => {
          if (reconciliationNote) {
            transactionNotes[transactionId] = reconciliationNote;
          }
        }
      );

      this.setState({
        isReady: true,
        report: {
          dateFrom,
          dateTo,
          id: reportId,
          reportName,
          statementBalance: endingBalance,
          beginningBalance,
          transactionNotes
        },
        step: 2
      });
    }
  };

  getReportName = () => {
    const date = new Date();
    return `${MonthNames[date.getMonth()]} ${date.getFullYear()}`;
  };

  onChange = (name, value) => {
    this.setState({ report: { ...this.state.report, [name]: value } });
  };

  updateReport = (report) => {
    this.setState({ report });
  }

  continue = () => {
    this.setState({ step: 2 });
  };

  cancel = () => {
    this.setState(
      { report: this.report, submitAttempted: false, step: 1 },
      () => {
          this.props.close();
          this.props.clearReconciliationDetails(); //TODO - why wouldnt we clear details here too?  [testing req]
      }
    );
  };

  render() {
    const { isReady, report, step } = this.state;
    const { 
        fund, newReconciliationReport, reconciliationAdjustments, 
        reconciliationBalance, reconciliationCredits, reconciliationPayments,
        reconciliationReportDetails, reconciliationReports, show
    } = this.props;

    return (
      <Modal modalShowing={show}>
        <div className="modal-container">
          <div
            className={`modal ${
              step === 1 ? "large-modal" : "reconcile-modal"
            }`}
          >
            {!isReady ? (
              <div>
                <div className="bordered-modal-header">
                  <div>
                    <h4 className="page-header">{`Reconcile - ${
                      fund.name
                    }`}</h4>
                  </div>
                  <i
                    className="icon ion-ios-close-empty"
                    onClick={this.cancel}
                  />
                </div>
                <LoadingSpinner />
              </div>
            ) : reconciliationReportDetails.loading ? (
              <LoadingSpinner />
            ) : !!report.id &&
              !reconciliationReportDetails.success ? (
              <p className="error-text">
                Sorry, something went wrong and we could not load your
                reconciliation report. Please try again.
              </p>
            ) : step === 1 ? (
              <BankReconciliationStep1
                report={report}
                fundName={fund.name}
                onChange={this.onChange}
                continue={this.continue}
                cancel={this.cancel}
                isIsraeli={fund.department === Departments.IL}
                wasPreviouslyReconciled={
                  !!reconciliationReports.data
                    .lastReconciliationEndDate
                }
              />
            ) : (
              <BankReconciliationStep2
                {...newReconciliationReport}
                cancel={this.cancel}
                onChange={this.onChange}
                updateReport={this.updateReport}
                createReconciliationReport={
                  this.props.createReconciliationReport
                }
                createAndCompleteReconciliationReport={
                  this.props.createAndCompleteReconciliationReport
                }
                updateReconciliationReport={
                  this.props.updateReconciliationReport
                }
                completeReconciliationReport={
                  this.props.completeReconciliationReport
                }
                clearReconciliationDetails={
                  this.props.clearReconciliationDetails
                }
                reconciliationBalance={reconciliationBalance}
                report={report}

                isIsraeli={fund.department === Departments.IL}
                fundId={fund.fundId}
                fundName={fund.name}
                selectPayment={this.props.selectPayment}
                reconciliationPayments={reconciliationPayments}
                getPayments={(...passProps) =>
                  this.props.getPayments(
                    report.dateFrom,
                    report.dateTo,
                    ...passProps
                  )
                }

                selectCredit={this.props.selectCredit}
                reconciliationCredits={reconciliationCredits}
                getCredits={(...passProps) =>
                  this.props.getCredits(
                    report.dateFrom,
                    report.dateTo,
                    ...passProps
                  )
                }

                reconciliationAdjustments={reconciliationAdjustments}
                updateAdjustments={this.props.updateAdjustments}
              />
            )}
          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/accountingComponents/fundDetails/NewBankReconciliation/BankReconciliationModal.jsx